<form [formGroup]="leadAttributesForm" class="lead-attributes-form">
  <div class="form-grid">
    @if (hasGetSetLeadsPermission) {
      <div class="form-group">
        <label for="assignedTo">Assign To</label>
        <input id="assignedTo" type="text" [value]="currentUsername" readonly />
      </div>
    }

    <!-- <div class="form-group">
      <label for="leadStatus" class="required">Lead Status</label>
      <select id="leadStatus" formControlName="leadStatus">
        <option value="">Select Status</option>
        <option value="Under review">Under review</option>
        <option value="Further information required">
          Further information required
        </option>
        <option value="Prospective client">Prospective client</option>
        <option value="On hold">On hold</option>
        <option value="Declined">Declined</option>
        <option value="Not currently pursuing">Not currently pursuing</option>
        <option value="Active client">Active client</option>
        <option value="Request lead contact">Request lead contact</option>
      </select>
      @if (
        leadAttributesForm.get("leadStatus")?.touched &&
        leadAttributesForm.get("leadStatus")?.invalid
      ) {
        <span class="error-message">Lead status is required</span>
      }
    </div>

    <div class="form-group">
      <label for="statusNotes">Status Notes</label>
      <textarea
        id="statusNotes"
        formControlName="statusNotes"
        rows="3"
      ></textarea>
    </div>

    <div class="form-group">
      <label for="viabilityRating">Viability Rating</label>
      <select id="viabilityRating" formControlName="viabilityRating">
        <option value="">Select Rating</option>
        <option value="Low viability">Low viability</option>
        <option value="Below average viability">Below average viability</option>
        <option value="Average viability">Average viability</option>
        <option value="Above average viability">Above average viability</option>
        <option value="High viability">High viability</option>
      </select>
    </div> -->

    <div class="form-group">
      <label for="ownerGender">Owner Gender</label>
      <select id="ownerGender" formControlName="ownerGender">
        <option value="">Select Gender</option>
        <option [ngValue]="1">Male</option>
        <option [ngValue]="2">Female</option>
        <option [ngValue]="3">Non-Binary</option>
        <option [ngValue]="4">Prefer not to disclose</option>
      </select>
    </div>
    <div class="form-group">
      <label for="ownerEthnicity">Owner Ethnicity</label>
      <select id="ownerEthnicity" formControlName="ownerEthnicity">
        <option value="">Select Ethnicity</option>
        <option [ngValue]="2">Not Hispanic or Latino</option>
        <option [ngValue]="1">Hispanic or Latino</option>
      </select>
    </div>
    <div class="form-group">
      <label for="ownerRace">Owner Race</label>
      <select id="ownerRace" formControlName="ownerRace">
        <option value="">Select Race</option>
        <option [ngValue]="1">American Indian</option>
        <option [ngValue]="2">Alaskan Native</option>
        <option [ngValue]="3">Asian</option>
        <option [ngValue]="4">Black or African American</option>
        <option [ngValue]="5">Native Hawaiian</option>
        <option [ngValue]="6">Other Pacific Islander</option>
        <option [ngValue]="7">White</option>
        <option [ngValue]="8">Multi-racial</option>
      </select>
    </div>
    <!-- <div class="form-group">
      <label for="seekingPartnership">Seeking Partnership</label>
      <select id="seekingPartnership" formControlName="seekingPartnership">
        <option value="">Select Option</option>
        <option value="Seeking funding partner">Seeking funding partner</option>
        <option value="Seeking technical assistance">
          Seeking technical assistance
        </option>
        <option value="Unknown">Unknown</option>
      </select>
    </div> -->
  </div>

  <div class="radio-groups-wrapper">
    <div class="radio-group">
      <span class="radio-group-label">Owner has disability</span>
      <div class="radio-options">
        <div class="radio-option">
          <input
            type="radio"
            id="ownerDisabilityYes"
            formControlName="ownerDisability"
            [value]="true"
          />
          <label for="ownerDisabilityYes">Yes</label>
        </div>
        <div class="radio-option">
          <input
            type="radio"
            id="ownerDisabilityNo"
            formControlName="ownerDisability"
            [value]="false"
          />
          <label for="ownerDisabilityNo">No</label>
        </div>
      </div>
    </div>
  </div>
</form>
